export default "/Frontend/dist/image-white.41aa99da6695a8072215326fd2b88c3a.svg";